import actions from './actions';

const {
  LIST_TIPO_ORIGEN_PACIENTE,
  LIST_TIPO_ORIGEN_PACIENTE_SELECTBOX,
  CREATE_TIPO_ORIGEN_PACIENTE,
  READ_TIPO_ORIGEN_PACIENTE,
  UPDATE_TIPO_ORIGEN_PACIENTE,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const tipoOrigenPacienteCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_TIPO_ORIGEN_PACIENTE:
      return {
        ...state,
        data: data
      }
    case LIST_TIPO_ORIGEN_PACIENTE_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_TIPO_ORIGEN_PACIENTE:
      return {
        ...state,
        record: data
      }
    case READ_TIPO_ORIGEN_PACIENTE:
      return {
        ...state,
        record: data
      }
    case UPDATE_TIPO_ORIGEN_PACIENTE:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default tipoOrigenPacienteCrudReducer;
